module.exports = {"toClipboard":"Sao chép","copied":"Đã Sao chép","notCopied":"Không được Sao chép"};